import { render, staticRenderFns } from "./banks-details.vue?vue&type=template&id=3c8e2af2&"
import script from "./banks-details.vue?vue&type=script&lang=js&"
export * from "./banks-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports